import React from 'react'
import { fs } from '../controls/Constants'
import { FaYoutube, FaDiscord, FaTiktok } from 'react-icons/fa'

const Contact = () => {
    const navigate = (link: string) => {
        window.open(link, "_blank", "noopener,noreferrer")
    }
    return (
        <>
            <main>
                <section>
                    <h1>Contact Us</h1>
                    <p className={`${fs}`}>We value your feedback and are here to help with any questions, concerns, or support you may need. <br />
                     Whether you're looking for assistance with the Kari Arduino Library, have suggestions for improvements, or simply want to connect, we are here for you.</p>

                </section> 
                <section>
                    <h1>Join Our Community on Discord</h1>
                    <p className={`${fs}`}>Stay connected with us and the community by joining our Discord server. 
                    Here, you can participate in discussions, <br /> get support, share your projects, and stay updated with the latest news.</p>
                    <ul className={`${fs}`}>
                        <li><strong>Discord:</strong><a href="https://discord.gg/rva2yrzqGw" target="_blank" rel="noopener noreferrer" className="links"> Join Kari Space</a></li>
                    </ul>

                </section> 
                <section>
                    <h1>Social Media</h1>
                    <p className={`${fs}`}>Stay updated with the latest news, tutorials, and community discussions by following us 
                        on our social media channels:</p>
                        <article className='social-media'>
                            <FaYoutube className="youtube" onClick={() => navigate("https://youtube.com/@tech_diaries_with_vincent?si=hYG6JHdfLZZAKd9l")}/>
                            <FaDiscord className="discord" onClick={()=> navigate("https://discord.gg/rva2yrzqGw")}/>
                            <FaTiktok className='tiktok' onClick={()=> navigate("https://www.tiktok.com/@vincent_circuit_corner?_t=ZM-8tG1411fJhd&_r=1")}/>
                        </article>
                </section> 
                <section>
                    <h1>Get in Touch</h1>
                    <p className={`${fs}`}>For any inquiries or support, please do not hesitate to reach out to us via Discord or through our social media profiles. 
                    <br />  We are dedicated to assisting you with any questions or concerns you may have about the Kari Arduino Library.</p>

                </section> 
            </main>
        </>
    )
}

export default Contact
